import { getPromotionDetails } from '@atlassian/mpac-api-client';
import { hooks, log } from '@atlassian/mpac-utils';
export const usePromotionDetails = (mpacBaseUrl, partnerId, promotionId) => {
  const {
    result,
    error,
    pending
  } = hooks.usePromise(() => getPromotionDetails(mpacBaseUrl, partnerId, promotionId));

  if (error) {
    log.error('PromotionDetails/hooks', "Failed to retrieve Promotion Details", {
      error
    });
  }

  return {
    pending,
    error,
    promotionDetails: result || {}
  };
};
export const formatPartnerAppsOptions = eligibleApps => eligibleApps.map(app => ({
  label: app.name,
  value: app.key
}));